import {Row} from "_core/components/common/UI";

// styles imports
import './Checkbox.scss';

export const Comment = `
	/**
	 *
	 * props の定義
	 *
	 * [set]
	 * 		id				...	スタイルシートid指定の文字列
	 * 		class			...	スタイルシートクラス指定の文字列
	 * 		checked			...	チェックボックスの初期状態
	 *
	 * [act]
	 * 		onchange		...	変更時に実行したい処理
	 */
	 `

export const Checkbox = (props) => {
	return (	
			<Row className="spacing-8px">
				<input
					type="checkbox"
					id={props.id}
					name={props.name}
					value={props.value}
					checked={props.checked}
					onChange={(props.onChange) ? props.onChange : null}
				></input>
				<div>{props.children}</div>
			</Row>
	);
}
export default Checkbox;